(function() {
  "use strict";
  var KEY = "anern48v51vlifepo4";
  var ROOT = ".anern-48v-51v-lifepo4-page";
  window.__anernPages = window.__anernPages || {};
  if (window.__anernPages[KEY]) return;
  var state = { observer: null };

  function withinRoot(node) {
    if (!node) return false;
    if (node.matches && node.matches(ROOT)) return true;
    return !!(node.closest && node.closest(ROOT));
  }

  function initTabs(scope) {
    scope.querySelectorAll(ROOT + " .tab-system").forEach(function(system) {
      if (system.dataset.anernTabsInit === "true") return;
      system.dataset.anernTabsInit = "true";
      var buttons = Array.from(system.querySelectorAll("[data-tab-target]"));
      var panels = Array.from(system.querySelectorAll("[data-tab-panel]"));
      if (!buttons.length || !panels.length) return;
      function activate(button, focus) {
        var target = button.getAttribute("data-tab-target");
        buttons.forEach(function(item) {
          var selected = item === button;
          item.setAttribute("aria-selected", String(selected));
          item.tabIndex = selected ? 0 : -1;
        });
        panels.forEach(function(panel) { panel.hidden = panel.getAttribute("data-tab-panel") !== target; });
        if (focus) button.focus();
      }
      buttons.forEach(function(button, index) {
        button.addEventListener("click", function() { activate(button, false); });
        button.addEventListener("keydown", function(event) {
          if (!["ArrowLeft", "ArrowRight", "Home", "End"].includes(event.key)) return;
          event.preventDefault();
          var nextIndex = index;
          if (event.key === "ArrowLeft") nextIndex = (index - 1 + buttons.length) % buttons.length;
          if (event.key === "ArrowRight") nextIndex = (index + 1) % buttons.length;
          if (event.key === "Home") nextIndex = 0;
          if (event.key === "End") nextIndex = buttons.length - 1;
          activate(buttons[nextIndex], true);
        });
      });
    });
  }

  function initDefinitions(scope) {
    scope.querySelectorAll(ROOT + " [data-definition-toggle]").forEach(function(button) {
      if (button.dataset.anernDefinitionInit === "true") return;
      button.dataset.anernDefinitionInit = "true";
      var targetId = button.getAttribute("aria-controls");
      var pageRoot = button.closest(ROOT);
      var panel = pageRoot ? pageRoot.querySelector("#" + CSS.escape(targetId)) : null;
      if (!panel) return;
      button.addEventListener("click", function() {
        var open = button.getAttribute("aria-expanded") !== "true";
        button.setAttribute("aria-expanded", String(open));
        panel.classList.toggle("is-open", open);
      });
    });
  }

  function initFaq(scope) {
    scope.querySelectorAll(ROOT + " .faq-list").forEach(function(list) {
      if (list.dataset.anernFaqInit === "true") return;
      list.dataset.anernFaqInit = "true";
      list.addEventListener("toggle", function(event) {
        var opened = event.target;
        if (!(opened instanceof HTMLDetailsElement) || !opened.open) return;
        list.querySelectorAll("details[open]").forEach(function(item) { if (item !== opened) item.open = false; });
      }, true);
    });
  }

  function initRails(scope) {
    scope.querySelectorAll(ROOT + " [data-rail-controls]").forEach(function(controls) {
      if (controls.dataset.anernRailInit === "true") return;
      controls.dataset.anernRailInit = "true";
      var railId = controls.getAttribute("data-rail-controls");
      var pageRoot = controls.closest(ROOT);
      var rail = pageRoot ? pageRoot.querySelector("#" + CSS.escape(railId)) : null;
      if (!rail) return;
      controls.querySelectorAll("[data-rail-direction]").forEach(function(button) {
        button.addEventListener("click", function() {
          var direction = button.getAttribute("data-rail-direction") === "next" ? 1 : -1;
          rail.scrollBy({ left: direction * Math.min(380, rail.clientWidth * 0.84), behavior: "smooth" });
        });
      });
    });
  }

  function initReveal(scope) {
    var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var items = scope.querySelectorAll(ROOT + " .reveal:not(.is-visible)");
    if (reduced || !("IntersectionObserver" in window)) {
      items.forEach(function(item) { item.classList.add("is-visible"); });
      return;
    }
    if (!state.observer) {
      state.observer = new IntersectionObserver(function(entries, observer) {
        entries.forEach(function(entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add("is-visible");
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.12, rootMargin: "0px 0px -40px" });
    }
    items.forEach(function(item) { state.observer.observe(item); });
  }

  function initAnchors(scope) {
    scope.querySelectorAll(ROOT + " a[href^='#']").forEach(function(anchor) {
      if (anchor.dataset.anernAnchorInit === "true") return;
      anchor.dataset.anernAnchorInit = "true";
      anchor.addEventListener("click", function(event) {
        var id = anchor.getAttribute("href");
        if (!id || id === "#") return;
        var pageRoot = anchor.closest(ROOT);
        var target = pageRoot ? pageRoot.querySelector(id) : null;
        if (!target) return;
        event.preventDefault();
        var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
        target.scrollIntoView({ behavior: reduced ? "auto" : "smooth", block: "start" });
        if (history.replaceState) history.replaceState(null, "", id);
      });
    });
  }

  function init(scope) {
    if (!document.querySelector(ROOT)) return;
    initTabs(scope); initDefinitions(scope); initFaq(scope); initRails(scope); initReveal(scope); initAnchors(scope);
  }

  document.addEventListener("DOMContentLoaded", function() { init(document); });
  document.addEventListener("shopify:section:load", function(event) { init(event.target); });
  document.addEventListener("shopify:section:unload", function(event) {
    if (!state.observer || !withinRoot(event.target)) return;
    event.target.querySelectorAll(".reveal").forEach(function(item) { state.observer.unobserve(item); });
  });
  document.addEventListener("shopify:block:select", function(event) {
    if (!withinRoot(event.target)) return;
    var panel = event.target.closest("[data-tab-panel]");
    if (!panel) return;
    var system = panel.closest(".tab-system");
    if (!system) return;
    var target = panel.getAttribute("data-tab-panel");
    var button = system.querySelector('[data-tab-target="' + CSS.escape(target) + '"]');
    if (button) button.click();
  });

  window.__anernPages[KEY] = { init: init };
  init(document);
})();
